<template>
    <div class="attendance">
        <div class="main-wrapper">
            <layout-header></layout-header>
            <layout-sidebar></layout-sidebar>
            <!-- Page Wrapper -->
            <div class="page-wrapper">
                <div class="content container-fluid">
                    <!-- Page Header -->
                    <div class="page-header">
                        <div class="row">
                            <div class="col-sm-12">
                                <h3 class="page-title">Attendance</h3>
                                <ul class="breadcrumb">
                                    <li class="breadcrumb-item">
                                        <router-link to="/index">Dashboard</router-link>
                                    </li>
                                    <li class="breadcrumb-item active">Attendance</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <!-- /Page Header -->
                    <!-- Search Filter -->
                    <div class="row filter-row">
                        <div class="col-sm-6 col-md-3">
                            <div class="form-group form-focus">
                                <input type="text" class="form-control floating" v-model="name" @change="getFilteredName">
                                <label class="focus-label">Employee Name</label>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-3">
                            <div class="form-group form-focus select-focus">
                                <select class="form-control" style="height: 55px !important;" v-model="month">
                                                    <option>Select Month</option>
                                                    <option v-for="item in months" :key="item.value" :value="item.value">{{item.label}}</option>
                                                </select>
                                <label class="focus-label">Select Month</label>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-3">
                            <div class="form-group form-focus select-focus">
                                <select class="form-control" style="height: 55px !important;" v-model="year">
                                                    <option>Select Year</option>
                                                    <option v-for="item in years" :key="item.value" :value="parseInt(item.value)">{{item.label}}</option>
                                                </select>
                                <label class="focus-label">Select Year</label>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-3">
                            <a @click="onSubmit()" class="btn btn-success btn-block"> Search </a>
                        </div>
                    </div>
                    <!-- /Search Filter -->
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="table-responsive">
                                <table class="table table-striped custom-table table-nowrap mb-0">
                                    <thead>
                                        <tr>
                                            <th>Employee</th>
                                            <th>1</th>
                                            <th>2</th>
                                            <th>3</th>
                                            <th>4</th>
                                            <th>5</th>
                                            <th>6</th>
                                            <th>7</th>
                                            <th>8</th>
                                            <th>9</th>
                                            <th>10</th>
                                            <th>11</th>
                                            <th>12</th>
                                            <th>13</th>
                                            <th>14</th>
                                            <th>15</th>
                                            <th>16</th>
                                            <th>17</th>
                                            <th>18</th>
                                            <th>19</th>
                                            <th>20</th>
                                            <th>21</th>
                                            <th>22</th>
                                            <th>23</th>
                                            <th>24</th>
                                            <th>25</th>
                                            <th>26</th>
                                            <th>27</th>
                                            <th>28</th>
                                            <th>29</th>
                                            <th>30</th>
                                            <th>31</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr colspan="31" v-if="loading">
                                            <span>Loading.... Please wait</span>
                                        </tr>
                                        <tr v-for="item in attendances" :key="item.employeeId">
                                            <td>
                                                <h2 class="table-avatar">
                                                    <router-link to="/profile" class="avatar avatar-xs"><img alt=""
                                                            src="~@/assets/profiles/avatar-09.jpg"></router-link>
                                                    <router-link to="/profile">{{item.employee.firstName + ' ' + item.employee.lastName}}</router-link>
                                                </h2>
                                            </td>
                                            <td>
                                                <a @click="setAttendance(item.day1.id)"><i
                                                        class="fa fa-check text-success" v-if="item.day1.num == 1"></i>
                                                <div class="half-day" v-if="item.day1.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day1.num == 0"></i>
                                                </a>
                                            </td>
                                             <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day2.id)"
                                                    data-target="#attendance_info"><i v-if="item.day2.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day2.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day2.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day3.id)"
                                                    data-target="#attendance_info"><i v-if="item.day3.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day3.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day3.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day4.id)"
                                                    data-target="#attendance_info"><i v-if="item.day4.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day4.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day4.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day5.id)"
                                                    data-target="#attendance_info"><i v-if="item.day5.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day5.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day5.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day6.id)"
                                                    data-target="#attendance_info"><i v-if="item.day6.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day6.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day6.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day7.id)"
                                                    data-target="#attendance_info"><i v-if="item.day7.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day7.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day7.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day8.id)"
                                                    data-target="#attendance_info"><i v-if="item.day8.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day8.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day8.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day9.id)"
                                                    data-target="#attendance_info"><i v-if="item.day9.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day9.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day9.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day10.id)"
                                                    data-target="#attendance_info"><i v-if="item.day10.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day10.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day10.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day11.id)"
                                                    data-target="#attendance_info"><i v-if="item.day11.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day11.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day11.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day12.id)"
                                                    data-target="#attendance_info"><i v-if="item.day12.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day12.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day12.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day13.id)"
                                                    data-target="#attendance_info"><i v-if="item.day13.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day13.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day13.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day14.id)"
                                                    data-target="#attendance_info"><i v-if="item.day14.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day14.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day14.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day15.id)"
                                                    data-target="#attendance_info"><i v-if="item.day15.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day15.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day15.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day16.id)"
                                                    data-target="#attendance_info"><i v-if="item.day16.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day16.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day16.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day17.id)"
                                                    data-target="#attendance_info"><i v-if="item.day17.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day17.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day17.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day18.id)"
                                                    data-target="#attendance_info"><i v-if="item.day18.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day18.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day18.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day19.id)"
                                                    data-target="#attendance_info"><i v-if="item.day19.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day19.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day19.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day20.id)"
                                                    data-target="#attendance_info"><i v-if="item.day20.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day20.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day20.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day21.id)"
                                                    data-target="#attendance_info"><i v-if="item.day21.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day21.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day21.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day22.id)"
                                                    data-target="#attendance_info"><i v-if="item.day22.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day22.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day22.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day23.id)"
                                                    data-target="#attendance_info"><i v-if="item.day23.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day23.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day23.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day24.id)"
                                                    data-target="#attendance_info"><i v-if="item.day24.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day24.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day24.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day25.id)"
                                                    data-target="#attendance_info"><i v-if="item.day25.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day25.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day25.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day26.id)"
                                                    data-target="#attendance_info"><i v-if="item.day26.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day26.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day26.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day27.id)"
                                                    data-target="#attendance_info"><i v-if="item.day27.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day27.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day27.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day28.id)"
                                                    data-target="#attendance_info"><i v-if="item.day28.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day28.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day28.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day29.id)"
                                                    data-target="#attendance_info"><i v-if="item.day29.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day29.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day29.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day30.id)"
                                                    data-target="#attendance_info"><i v-if="item.day30.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day30.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day30.num == 0"></i></a>
                                            </td> <td>
                                                <a data-toggle="modal" @click="setAttendance(item.day31.id)"
                                                    data-target="#attendance_info"><i v-if="item.day31.num == 1"
                                                        class="fa fa-check text-success"></i>
                                                <div class="half-day" v-if="item.day31.num == 2">
                                                    <span class="first-off"><a
                                                            data-toggle="modal" data-target="#attendance_info"><i
                                                                class="fa fa-check text-success"></i></a></span>
                                                    <span class="first-off"><i
                                                            class="fa fa-close text-danger"></i></span>
                                                </div>
                                                <i class="fa fa-close text-danger" v-if="item.day31.num == 0"></i></a>
                                            </td>
                                        </tr>
                                        
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /Page Content -->

                <!-- Attendance Modal -->
                <v-dialog v-model="dialogDisplay" max-width="725px">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Attendance Info</h5>
                                <button type="button" class="close" @click="() => this.dialogDisplay = false">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="card punch-status">
                                            <div class="card-body">
                                                <h5 class="card-title">Timesheet <small class="text-muted">{{
                      new Date(lastPunch.attendedDate).toLocaleDateString("en-US", {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    }}</small></h5>
                                                <div class="punch-det">
                                                    <h6>Punch In at</h6>
                                                    <p>{{new Date(lastPunch.attendedDate).toLocaleDateString(
                          "en-US",
                          {
                            weekday: "long",
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          }
                        ) +
                        " " +
                        lastPunch.punchInTime
                      }}</p>
                                                </div>
                                                <div class="punch-info">
                                                    <div class="punch-hours">
                                                        <span>{{lastPunch.punchInTime
                          ? this.getTimeDifference() + " hrs"
                          : "0 hr"}}</span>
                                                    </div>
                                                </div>
                                                <div class="punch-det">
                                                    <h6>Punch Out at</h6>
                                                    <p>{{new Date(lastPunch.attendedDate).toLocaleDateString(
                          "en-US",
                          {
                            weekday: "long",
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          }
                        ) +
                        " " +
                        lastPunch.punchOutTime
                      }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                </v-dialog>
                <!-- /Attendance Modal -->

            </div>
            <!-- Page Wrapper -->
        </div>

    </div>
</template>

<script>
    import LayoutHeader from '@/components/layouts/Header.vue'
    import LayoutSidebar from '@/components/layouts/Sidebar.vue'
    import { attendanceService } from "@/services/attendanceService";
    import { authenticationService } from "@/services/authenticationService";
    export default {
        components: {
            LayoutHeader,
            LayoutSidebar,
        },
        data() {
            return {
                name: "",
                dialogDisplay: false,
                company: authenticationService.currentOfficeValue,
                attendances: [],
                noFilterAttendances: [],
                lastPunch: {},
                month: new Date().getMonth() + 1,
                year: new Date().getFullYear(),
                months: [
                { value: 1, label: 'January'}, { value: 2, label: 'February'}, { value: 3, label: 'March'},
                { value: 4, label: 'April'}, { value: 5, label: 'May'}, { value: 6, label: 'June'},
                { value: 7, label: 'July'}, { value: 8, label: 'August'}, { value: 9, label: 'September'},
                { value: 10, label: 'October'}, { value: 11, label: 'November'}, { value: 12, label: 'December'}
                ],
                years: [],
                loading: false
            }
        },
        watch: {
            name: function name() {
                this.getFilteredName()                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   
            }
        }, 
        methods: {
            setAttendance (item) {
                console.log(item)
                if(item){
                this.lastPunch = item
                this.dialogDisplay = true
                }
            },
            generateYears () {
                var result = [];
                for(var i = 2020; i < (new Date().getFullYear() + 20); i++)
                    result.push({value: i, label: i})

                    this.years = result;
            },
            getTimeDifference() {
      if (this.lastPunch.punchInTime) {
        var punchDate = new Date(
          new Date(this.lastPunch.attendedDate).toLocaleDateString("en-US", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          }) +
            " " +
            this.lastPunch.punchInTime
        );
        var punchoutDate = new Date(
          new Date(this.lastPunch.attendedDate).toLocaleDateString("en-US", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          }) +
            " " +
            this.lastPunch.punchOutTime
        );
        var diff = (punchDate.getTime() - punchoutDate.getTime()) / 1000;
        diff /= 60 * 60;
        return Math.abs(Math.round(diff));
      }
    },

            onSubmit () {
                this.loading = true
                var unit = JSON.parse(localStorage.getItem('companyUnit'))
                attendanceService.getMonthlyattendance(unit.id, this.month, this.year).then(
                    (model) => {
                        // console.log(model);
                        this.attendances = model;
                        this.noFilterAttendances = model;
                        this.loading = false
                    },
                    (error) => {
                        error = error;
                        this.loading = false
                    }
                );
            },
            getFilteredName () {
               this.loading = true
                var unit = JSON.parse(localStorage.getItem('companyUnit'))
                attendanceService.getMonthlyattendance(unit.id, this.month, this.year).then(
                    (model) => {
                        // console.log(model);
                        
                        const a = model.filter(emp => {
                            //console.log(emp.employee.firstName)
                            return (emp.employee.firstName.toLowerCase().includes(this.name.toLowerCase())) 
                                ||  (emp.employee.lastName.toLowerCase().includes(this.name.toLowerCase()))
                        })
                        if (this.name) {
                            this.attendances = a;
                        }
                        if (!this.name) {
                            this.attendances = model;
                        }
                        // this.attendances = model;
                        // this.noFilterAttendances = model;
                        this.loading = false
                    },
                    (error) => {
                        error = error;
                        this.loading = false
                    }
                );

                // const a = this.attendances.filter(emp => {
                //     return emp.employee.firstName.toLowerCase().includes(this.name.toLowerCase())                   
                // })
                // if (this.name) {
                // return this.attendances = a;
                // } else {
                //     return this.attendances = this.noFilterAttendances;
                // }   
            }
        },
        mounted() {
            // Select 2
            if ($('.select').length > 0) {
                $('.select').select2({
                    minimumResultsForSearch: -1,
                    width: '100%'
                });
            }
            this.generateYears();
            this.onSubmit();
            // Multiselect
            if ($('#customleave_select').length > 0) {
                $('#customleave_select').multiselect();
            }
            if ($('#edit_customleave_select').length > 0) {
                $('#edit_customleave_select').multiselect();
            }
            if ($('.floating').length > 0) {
                $('.floating').on('focus blur', function (e) {
                    $(this).parents('.form-focus').toggleClass('focused', (e.type === 'focus' || this.value.length > 0));
                }).trigger('blur');
            }
        },
        name: 'attendance'
    }
</script>


// WEBPACK FOOTER //
// src/components/attendance/attendance.vue